import React from 'react';
import ServicePage from '../components/services/ServicePage';
import vehicleSignwriting from '../data/services/vehicle-signwriting';

const VehicleSignwriting: React.FC = () => <ServicePage data={vehicleSignwriting} />;

export default VehicleSignwriting;
